import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const policyApi = createAsyncThunk("policy", async () => {
  const response = await axiosInstance.get(`/policy/getAll`);
  return response.data;
});

const policySlice = createSlice({
  name: "policy",
  initialState: {
    policy: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(policyApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(policyApi.fulfilled, (state, action) => {
        state.policy = action.payload;
        state.loading = false;
      })
      .addCase(policyApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default policySlice.reducer;
